var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSe = function SvgSe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "se_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-53.421 0h682.67v512h-682.67z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#se_svg__a)",
    transform: "translate(50.082)scale(.9375)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#006aa7",
    d: "M-121.103.302h256V205.1h-256zm0 306.876h256v204.8h-256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecc00",
    d: "M-121.103 204.984h256v102.4h-256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecc00",
    d: "M133.843.01h102.4v511.997h-102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecc00",
    d: "M232.995 205.013h460.798v102.4H232.995z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006aa7",
    d: "M236.155 307.208h460.797v204.799H236.155zm0-306.906h460.797V205.1H236.155z"
  })))));
};
export default SvgSe;